import * as Yup from 'yup';

 const redemptionsSchema = Yup.object().shape({
    date: Yup.string().required('Required'),
    reward: Yup.string().required('Required'),
    code: Yup.string().required('Required'),
    status: Yup.string().required('Required'),   
    member: Yup.string().required('Required'), 
 });

export default redemptionsSchema
